module.exports = __webpack_public_path__ + "static/ithor-plate-77da43fe7786cc63c1693002d7f22058.gif";